import React from 'react'
import styles from 'components/shared/icons/icons.module.scss'
import cn from 'classnames'
import { Star } from 'lucide-react'

export interface StarredIconProps {
    contextStyles?: string
    hoverStyles?: string
    selectedStyles?: string
    showIcon?: boolean
}

export default function StarredIcon({
    contextStyles,
    hoverStyles,
    selectedStyles,
}: StarredIconProps) {
    return (
        <div
            className={cn(
                styles.iconComp,
                styles.starredIcon,
                contextStyles,
                hoverStyles,
                selectedStyles,
            )}
        >
            <Star />
        </div>
    )
}
